<template>
	<AppModal :settings="modalSettings">
		<MileageModalContent />
	</AppModal>
</template>

<script>
import AppModal from '@/components/App/AppModal';
import MileageModalContent from './MileageModalContent';

export default {
	components: {
		AppModal,
		MileageModalContent,
	},
	data() {
		return {
			modalSettings: {
				name: 'modalMileage',
				title: '마일리지 적립 및 이용',
				isOpen: true,
			},
		};
	},
};
</script>
